import { FIELD_PATHS, FREQUENCY_OPTIONS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DropdownField, StringDisplay } from '../../Fields';
import { EditableViewProps, FunnelViewProps, StringReadOnlyViewProps } from '../types';

interface IncomeFrequencyEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  disableFailMessage?: boolean;
}

export function IncomeFrequencyEditableView(props: IncomeFrequencyEditableViewProps) {
  const { disableFailMessage, incomeIndex, isOptional, isDisabled } = props;
  return (
    <DropdownField
      name={FIELD_PATHS.INCOME_FREQUENCY(incomeIndex)}
      options={FREQUENCY_OPTIONS}
      isOptional={isOptional}
      isDisabled={isDisabled}
      disableFailMessage={disableFailMessage}
      isFullWidth
      shouldAnchorList
    />
  );
}

interface IncomeFrequencyFunnelViewProps extends FunnelViewProps, IncomeEntityIndex {}

export function IncomeFrequencyFunnelView(props: IncomeFrequencyFunnelViewProps) {
  const { incomeIndex, ...rest } = props;
  return (
    <DropdownField {...rest} name={FIELD_PATHS.INCOME_FREQUENCY(incomeIndex)} options={FREQUENCY_OPTIONS} isFullWidth />
  );
}

export const IncomeFrequencyFunnelReadOnlyView = (props: StringReadOnlyViewProps) => <StringDisplay {...props} />;
